import { FC } from 'react'
import { useQuery } from 'react-query'
import { fetchPostById } from 'src/services'
import Layout from 'src/containers/Layout/Layout'
import PostContainer from 'src/containers/Post/PostDetail'
import Loading from 'src/components/Loading/Loading'
import { Category } from 'src/types'
import { ids } from 'src/shared/constants'

const AboutPage: FC = () => {
  const { data: post, isFetching, isLoading } = useQuery('about', () =>
    fetchPostById(ids[Category.About]),
  )
  if (isFetching || isLoading || !post) return <Loading />
  return (
    <Layout>
      <PostContainer post={post} hidePV />
    </Layout>
  )
}

export default AboutPage
